import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  fetchEmailTemplates,
  fetchEmailTemplatePlaceholders,
  sendEmailUsingTemplate,
} from "../services/emailTemplateService";

/**
 * Hook to fetch all email templates
 */
export const useEmailTemplates = () => {
  return useQuery({
    queryKey: ["emailTemplates"],
    queryFn: fetchEmailTemplates,
    staleTime: 5 * 60 * 1000, // 5 min cache
    refetchOnMount: "always"
  });
};

/**
 * Hook to fetch placeholder definitions
 */
export const useEmailTemplatePlaceholders = () => {
  return useQuery({
    queryKey: ["emailTemplatePlaceholders"],
    queryFn: fetchEmailTemplatePlaceholders,
    staleTime: 10 * 60 * 1000, // 10 min cache
  });
};

/**
 * Hook to send email using a template
 */
export const useSendEmailUsingTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendEmailUsingTemplate,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["leadFollowUps"] });
      toast.success(data?.message || "Email sent successfully!");
    },
    onError: (error) => {
      toast.error(error.message || "Failed to send email");
    },
  });
};